import ApplicationController from '../application_controller'

class LocationOnlineController extends ApplicationController {
  static values = { appointmentTypeOnlines: Array }
  static targets = [
    'appointmentType',
    'locationId',
    'locationIdBlock',
    'locationOnlineBlock'
  ]

  connect () {
    $(this.appointmentTypeTarget).on('change', this.appointmentTypeChange.bind(this))
  }

  appointmentTypeChange (event) {
    const value = $(event.target).val()
    if (this.onlineValue(value) === true) {
      $(this.locationIdTarget).val(null).trigger('change')
      this.locationIdBlockTarget?.classList?.add('d-none')
      this.locationOnlineBlockTarget?.classList?.remove('d-none')
    } else {
      this.locationIdBlockTarget?.classList?.remove('d-none')
      this.locationOnlineBlockTarget?.classList?.add('d-none')
    }
  }

  onlineValue (id) {
    const found = this.appointmentTypeOnlinesValue.find(item => item[0] === parseInt(id))
    return found ? found[1] : null
  }
}

export default LocationOnlineController
